enum ListType {
  Table = 'table',
  MinimalTable = 'minimal-table',
  Assignment = 'assignment'
}

export default ListType
